import {Directive, HostBinding, HostListener, Input, Renderer2} from '@angular/core';
import * as fromDragAndDrop from '../reducers';
import {Store} from '@ngrx/store';
import {DragEnd, DragStart} from '../actions/drag.actions';

@Directive({
  selector: '[awairDraggable]'
})
export class DraggableDirective {

  // This is to prevent highlighting when dragged
  @HostBinding('style.user-select') hostUserSelect: string = 'none';
  @HostBinding('style.-webkit-user-select') hostWebkitUserSelect: string = 'none';
  @HostBinding('style.-moz-user-select') hostMozUserSelect: string = 'none';
  @HostBinding('style.cursor') hostCursor: string = 'pointer';

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    // This is to prevent mouse cursor changing to text in Safari
    event.preventDefault();

    this.isDragged = true;

    // Create dragImage
    if (this.imgSrc != null) {
      this.image = this.positionDragImage(this.createDragImage(this.imgSrc), event);
      this.renderer2.insertBefore(document.body.parentNode, this.image, document.body);
    }

    this.dragAndDropStore.dispatch(new DragStart({
      dragZone: this.zone,
      data: this.data
    }));
  }

  @HostListener('document: mousemove', ['$event'])
  onDocumentMouseMove(event: MouseEvent) {
    if (this.isDragged && event.buttons > 0) {
      document.body.style.cursor = 'pointer';

      // Position drag image
      if (this.image != null) {
        this.image = this.positionDragImage(this.image, event);
      }
    }
  }

  @HostListener('document: mouseup', ['$event'])
  onDocumentMouseUp(event: MouseEvent) {
    if (this.isDragged) {
      document.body.style.cursor = 'auto';
      this.isDragged = false;

      // Remove dragImage
      if (this.image != null) {
        this.renderer2.removeChild(document.body.parentNode, this.image);
      }

      this.dragAndDropStore.dispatch(new DragEnd());
    }
  }

  @Input() imgSrc: string;

  @Input() zone: string;
  @Input() data: any;

  isDragged: boolean = false;
  image: HTMLImageElement;

  constructor(private dragAndDropStore: Store<fromDragAndDrop.State>,
              private renderer2: Renderer2) {
  }

  private createDragImage(imgSrc: string): HTMLImageElement {
    const dragImage = this.renderer2.createElement('img');
    dragImage.src = imgSrc;
    dragImage.style.position = 'absolute';
    dragImage.style.pointerEvents = 'none';
    dragImage.style.zIndex = 10000;

    return dragImage;
  }

  private positionDragImage(image: HTMLImageElement, event: MouseEvent): HTMLImageElement {
    image.style.left =  `${event.clientX}px`;
    image.style.top = `${event.clientY}px`;
    image.style.transform = 'translate(-50%, -50%)';

    return image;
  }
}
